// @ts-expect-error Untyped import
import { NumberFormats } from './propertyFormatter';
/**
 * This returns the overrides to send to the propertyFormatter function based on propertyType.
 * @param {string} propertyType The type of the property.
 * @param {boolean} abbreviateIfPossible Whether to abbreviate the property if possible
 * @returns {PropertyFormatterOverrides} The overrides to send to the propertyFormatter function.
 */
export const getPropertyFormatterOverrides = (propertyType, abbreviateIfPossible) => {
  switch (propertyType) {
    case NumberFormats.number:
      return {
        abbreviate: abbreviateIfPossible || undefined,
        maxFractionDigits: 2
      };
    case NumberFormats.currency:
      return abbreviateIfPossible ? {
        abbreviate: true,
        maximumFractionDigits: 2
      } : {};
    default:
      return {};
  }
};